import styled from 'styled-components';
import { Col, Heading2 } from '@ovotech/element-v5';

export const COLORS = {
  PRIMARY_GREEN: '#2c5530',
  STEP_INDICATOR: '#666',
} as const;

export const StepIndicator = styled.p`
  font-size: 16px;
  color: #00261c;
  font-weight: 500;
  margin: 10px 0 0 0;
  text-align: center;
`;

export const CenteredCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
`;

export const StyledImage = styled.img`
  width: 200px;
  height: 200px;
  object-fit: cover;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #ebe7e3;
`;

export const ModalStepTitle = styled(Heading2)`
  font-size: 28px;
  font-weight: 900;
  color: #00261c;
  margin-bottom: 16px;
  ${({ theme }) => theme.mediaQueries.mediumAndUp} {
    font-size: 32px;
  }
`;

export const StyledChevronRight = styled.img`
  margin-left: 5px;
  vertical-align: sub;
`;
